module.exports = __webpack_public_path__ + "static/img/bs_content3.9b3a6c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs_content3.png
// module id = f1TT
// module chunks = 0